module.exports = __webpack_public_path__ + "img/met-glasses.41be586f.png";